import {availableCountries, getCountryCode} from './CountryRestrictionUtility';

/**
 * @author Johannes Sommer <j.sommer@andersundsehr.com>
 */
export class CountryRestrictionController {
  private readonly countryRestrictionSelector: string = '.js-countryLimitation';
  private readonly country: string = '';

  public constructor() {
    const $countryRestrictedElements = $(this.countryRestrictionSelector);
    if ($countryRestrictedElements.length > 0) {
      this.country = getCountryCode();
      $countryRestrictedElements.each((index, element) => {
        this.applyRestrictionForElement(element);
      });
    }
  }

  protected applyRestrictionForElement(element: HTMLElement): void {
    const $element = $(element);
    const countryArray = ($element.data('countrylimitation') || '').split(',');

    if ($element.hasClass('js-restrictedContentElement')) {
      this.showRestrictedElement($element, countryArray);
    } else {
      // Legacy function
      this.hideRestrictedElement($element, countryArray);
    }
  }

  private showRestrictedElement($element: JQuery, countryArray: string[]): void {
    if (($.inArray('others', countryArray) !== -1
      && $.inArray(this.country, availableCountries) === -1)
      || $.inArray(this.country, countryArray) !== -1) {
      const $html = $($element.html().replace('<!--restrictionreplacement', '').replace('-->', ''));
      $element.replaceWith($html);
    }
  }

  /**
   * Legacy function for single use cases (e.g. one navigation point)
   *
   * @param $element
   * @param countryArray
   */
  private hideRestrictedElement($element: JQuery, countryArray: string[]): void {
    if (($.inArray('others', countryArray) !== -1
      && $.inArray(this.country, availableCountries) !== -1)
      || $.inArray(this.country, countryArray) === -1) {
      $element.addClass('hide');
    }
  }
}
